import React from 'react';
import { Link } from 'react-router-dom';
import SeoHead from '@/components/layout/SeoHead';
import { ArrowUpRight, Trash2, Home, Heart, HandHeart, Refrigerator, Sofa, HardHat, TreePine } from 'lucide-react';
import { SERVICES } from '@/data/site';
import HowItWorks from '@/components/sections/HowItWorks';
import OurProcess from '@/components/sections/OurProcess';
import Pricing from '@/components/sections/Pricing';
import CTABand from '@/components/sections/CTABand';

const ICON_MAP = { Trash2, Home, Heart, HandHeart, Refrigerator, Sofa, HardHat, TreePine };

export default function Services() {
  return (
    <>
      <SeoHead
        title="Services | Ohana Property Services"
        description="Junk removal, full property cleanouts, estate cleanouts, debris removal, and donation-conscious recovery in Central Indiana."
        canonical="https://ohanapropertyexperts.com/services"
      />

      <section className="bg-ohana-primary text-ohana-bg">
        <div className="container-ohana pt-24 pb-20 md:pt-32 md:pb-28">
          <p className="overline">Services</p>
          <h1 className="mt-4 font-serif text-5xl md:text-6xl lg:text-7xl leading-[1.05] max-w-4xl">
            Every kind of cleanout, handled by one team.
          </h1>
          <p className="mt-6 text-lg md:text-xl text-ohana-bg/75 max-w-2xl">
            From a single bulky pickup to a full property transition, here's what we do.
          </p>
        </div>
      </section>

      <section className="section-pad bg-ohana-bg" data-testid="services-list">
        <div className="container-ohana grid grid-cols-1 md:grid-cols-2 gap-6">
          {SERVICES.map((s) => {
            const Ico = ICON_MAP[s.icon];
            return (
              <Link
                key={s.slug}
                to={`/${s.slug}`}
                className="group rounded-2xl border border-ohana-border bg-white p-8 transition-all hover:-translate-y-1 hover:shadow-xl hover:shadow-ohana-primary/5"
                data-testid={`services-list-${s.slug}`}
              >
                <div className="flex items-start justify-between">
                  <span className="grid h-12 w-12 place-items-center rounded-xl bg-ohana-surface text-ohana-primary">
                    {Ico && <Ico className="h-6 w-6" />}
                  </span>
                  <ArrowUpRight className="h-5 w-5 text-ohana-primary transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
                </div>
                <h2 className="mt-6 font-serif text-2xl md:text-3xl text-ohana-primary leading-snug">
                  {s.title}
                </h2>
                <p className="mt-3 text-ohana-text-muted leading-relaxed">{s.short}</p>
                <p className="mt-4 text-sm font-semibold text-ohana-accent">{s.pricingNote}</p>
              </Link>
            );
          })}
        </div>
      </section>

      <HowItWorks />
      <OurProcess />
      <Pricing showHomepageLink />
      <CTABand />
    </>
  );
}
